import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters:{},
  actions:{
  },
  mutations:{
  },
  modules: (r => {
    var modules={};
    r.keys().map(function(key){
      var index=key.substring(2,key.indexOf('/',2));
      modules[index]=r(key).default;
    });
    return modules;
  })(require.context('@/store/modules/', true, /^([\s\S])+\/index\.js$/))
})



// WEBPACK FOOTER //
// ./src/store/index.js